import { Routes } from 'react-router';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring';

import { Greeting } from './Greeting';
import { Login } from './Login';

export const CandidateAuth = () => {
  return (
    <Routes>
      <Route path="login" element={<Greeting />} />
      <Route path="candidate" element={<Login />} />
    </Routes>
  );
};
